import useCart, { CartHook } from "@/lib/hooks/useCart";
import useLocation from "@/lib/hooks/useLocation";
import PaymentListSVG from "@/public/icons/16px/list.svg";
import { useRouter } from "next/navigation";
import React from "react";
import styles from "./cart-summary.module.css";
const CartSummary = ({
  summary,
  modal,
  labels,
  missingYarns,
}: {
  summary: CartHook["cart"]["summary"] | undefined;
  modal?: CartHook["modal"];
  labels?: React.JSX.Element;
  missingYarns?: boolean;
}) => {
  const router = useRouter();
  const { currency } = useLocation();
  const { cart } = useCart();
  const goToCheckout = () => {
    if (modal) modal?.toggleModal();
    router.push("/checkout");
    // eventBeginCheckout({
    //   currency: currency || "",
    //   value: cart.summary?.prices.totalAsNumber,
    //   items: cart.items.map((item) => convertCartToGTagItem(item))
    // });
  };

  const closeModal = () => {
    if (modal) modal?.toggleModal();
  };

  const emptyCart = !cart.summary?.totalQuantity;

  return (
    <div className={styles.summary}>
      <div className={styles.summaryTexts}>
        <div className={styles.subtotals}>
          <span>
            <p>Delsum</p>
            <p>{summary?.prices?.total ?? "0,-"}</p>
          </span>

          {!!summary?.discount?.[0]?.priceOff && (
            <span>
              <p>Rabatt</p>
              <p>{summary?.discount?.[0]?.priceOff ?? "0"},-</p>
            </span>
          )}

          <span>
            <p>Frakt</p>
            <p>{summary?.prices?.shipping ?? "0,-"}</p>
          </span>
        </div>

        <span className={styles.grandtotal}>
          <p>Total</p>
          <p>{summary?.prices?.grandTotal ?? "0,-"}</p>
        </span>
      </div>

      {labels}

      {modal && (
        <button
          disabled={missingYarns || emptyCart}
          onClick={goToCheckout}
          type="button"
          className={styles["checkout-button"]}
        >
          Fortsett til utsjekk
        </button>
      )}
      <PaymentListSVG />
    </div>
  );
};

export default CartSummary;
